// Bilingual (EN / AZ) static catalogue for Az.r.Oil.
// Technical values (CAS, HS, formulas, percentages, volumes) are language-neutral.

export const groups = [
  {
    slug: "chemicals",
    code: "A",
    name: { en: "Chemicals", az: "Kimyəvi Maddələr" },
    short: {
      en: "Industrial and food-grade chemistries supplied to documented specifications.",
      az: "Sənədləşdirilmiş spesifikasiyalara uyğun təchiz olunan sənaye və qida təyinatlı kimyalar.",
    },
  },
  {
    slug: "tools-ppe",
    code: "B",
    name: { en: "Industrial Tools & PPE", az: "Sənaye Alətləri və FQV" },
    short: {
      en: "Hand tools, hydraulic equipment and personal protective equipment for field operations.",
      az: "Sahə əməliyyatları üçün əl alətləri, hidravlik avadanlıq və fərdi qoruyucu vasitələr.",
    },
  },
];

export const categories = [
  {
    slug: "acids",
    code: "01",
    name: { en: "Acids", az: "Turşular" },
    short: {
      en: "Mineral and organic acids for processing, neutralisation and chemical synthesis.",
      az: "Emal, neytrallaşdırma və kimyəvi sintez üçün mineral və üzvi turşular.",
    },
    long: {
      en: "Strong and food-grade acids used across industrial neutralisation, metal treatment, fertiliser production, food acidulation and chemical synthesis routes.",
      az: "Sənaye neytrallaşdırması, metal emalı, gübrə istehsalı, qida turşulaşdırması və kimyəvi sintez yollarında istifadə olunan güclü və qida dərəcəli turşular.",
    },
  },
  {
    slug: "alkalis",
    code: "02",
    name: { en: "Alkalis", az: "Qələvilər" },
    short: {
      en: "Caustic and basic chemistries for neutralisation, saponification and process control.",
      az: "Neytrallaşdırma, sabunlaşdırma və proses nəzarəti üçün kaustik və əsasi kimyalar.",
    },
    long: {
      en: "Strong inorganic alkalis specified across pulp and paper, water treatment, detergents, alumina processing, glass manufacturing and general pH regulation.",
      az: "Sellüloz və kağız, su təmizləmə, yuyucu vasitələr, alüminium oksidi emalı, şüşə istehsalı və ümumi pH tənzimlənməsində istifadə olunan güclü qeyri-üzvi qələvilər.",
    },
  },
  {
    slug: "oxidizing-agents",
    code: "03",
    name: { en: "Oxidizing Agents", az: "Oksidləşdirici Agentlər" },
    short: {
      en: "Oxidisers for water treatment, disinfection and bleaching applications.",
      az: "Su təmizləmə, dezinfeksiya və ağartma tətbiqləri üçün oksidləşdiricilər.",
    },
    long: {
      en: "Industrial oxidising chemistries used in disinfection, bleaching, water and effluent treatment, and as reagents in chemical processing.",
      az: "Dezinfeksiya, ağartma, su və tullantı sularının təmizlənməsində və kimyəvi emalda reagent kimi istifadə olunan sənaye oksidləşdirici kimyaları.",
    },
  },
  {
    slug: "salts",
    code: "04",
    name: { en: "Salts", az: "Duzlar" },
    short: {
      en: "Inorganic and organic salts for water treatment, drilling, food and process chemistry.",
      az: "Su təmizləmə, qazma, qida və proses kimyası üçün qeyri-üzvi və üzvi duzlar.",
    },
    long: {
      en: "A broad range of metal salts used across coagulation, completion brines, fertilisers, food preservation, electroplating and general industrial processes.",
      az: "Koaqulyasiya, tamamlanma duzluqları, gübrələr, qida konservasiyası, qalvanik örtüklər və ümumi sənaye prosesləri üzrə geniş çeşiddə metal duzları.",
    },
  },
  {
    slug: "sulfides",
    code: "05",
    name: { en: "Sulfides", az: "Sulfidlər" },
    short: {
      en: "Inorganic sulfides used in mining, leather, dye and chemical processing.",
      az: "Mədən, dəri, boyaq və kimyəvi emalda istifadə olunan qeyri-üzvi sulfidlər.",
    },
    long: {
      en: "Industrial sulfide chemistries supplied for ore flotation, leather depilation, dye intermediates and reduction reactions in chemical manufacturing.",
      az: "Filiz flotasiyası, dəri tükdənləşdirmə, boyaq aralıq məhsulları və kimyəvi istehsalda reduksiya reaksiyaları üçün təchiz olunan sənaye sulfid kimyaları.",
    },
  },
  {
    slug: "solvents",
    code: "06",
    name: { en: "Solvents", az: "Həlledicilər" },
    short: {
      en: "High-purity organic solvents for cleaning, extraction and chemical manufacturing.",
      az: "Təmizləmə, ekstraksiya və kimyəvi istehsal üçün yüksək saflıqlı üzvi həlledicilər.",
    },
    long: {
      en: "Solvent-grade chemistries used in degreasing, extraction, electronics cleaning, coatings, and as intermediates in polymer and specialty chemical production.",
      az: "Yağsızlaşdırma, ekstraksiya, elektronika təmizliyi, örtüklər və polimer və xüsusi kimya istehsalında aralıq maddələr kimi istifadə olunan həlledici dərəcəli kimyalar.",
    },
  },
  {
    slug: "polyols-additives",
    code: "07",
    name: { en: "Polyols / Surfactants / Additives", az: "Poliollar / Səthi-aktiv maddələr / Əlavələr" },
    short: {
      en: "Functional additives, surfactants and polyols for oilfield and polymer formulations.",
      az: "Neft mədəni və polimer formulalar üçün funksional əlavələr, səthi-aktiv maddələr və poliollar.",
    },
    long: {
      en: "Polyether polyols, surfactants, emulsifiers and process additives used in polyurethane production, oilfield demulsification, formulation and specialty chemical applications.",
      az: "Poliuretan istehsalı, neft mədəni demulsifikasiya, formulasiya və xüsusi kimya tətbiqlərində istifadə olunan poliefir poliollar, səthi-aktiv maddələr, emulqatorlar və proses əlavələri.",
    },
  },
];

export const products = [
  {
    slug: "caustic-soda",
    name: { en: "Caustic Soda", az: "Kaustik Soda" },
    synonym: { en: "Sodium Hydroxide", az: "Natrium hidroksid" },
    categories: ["alkalis"],
    summary: {
      en: "A strong inorganic alkali used extensively in neutralisation, pH adjustment, saponification and process chemistry across manufacturing, pulp, water treatment and refining.",
      az: "İstehsal, sellüloz, su təmizləmə və neft emalı sahələrində neytrallaşdırma, pH tənzimləmə, sabunlaşdırma və proses kimyasında geniş istifadə olunan güclü qeyri-üzvi qələvi.",
    },
    description: {
      en: "Caustic Soda (Sodium Hydroxide, NaOH) is one of the most widely specified industrial alkalis. It is highly reactive, fully water-soluble and delivers strong, predictable neutralisation. Typical applications include pulp and paper, detergents, alumina processing, textile mercerisation, chemical intermediates and effluent neutralisation in water treatment plants.",
      az: "Kaustik soda (Natrium hidroksid, NaOH) ən geniş istifadə olunan sənaye qələvilərindən biridir. Yüksək reaktiv, suda tam həll olan və güclü, proqnozlaşdırıla bilən neytrallaşdırma təmin edir. Tipik tətbiqlərə sellüloz və kağız, yuyucu vasitələr, alüminium oksidinin emalı, toxuculuqda merserizasiya, kimyəvi aralıq maddələr və su təmizləmə qurğularında tullantı sularının neytrallaşdırılması daxildir.",
    },
    spec: {
      "CAS No.": "1310-73-2",
      "HS Code": "2815.12",
      "Chemical Formula": "NaOH",
      "Forms Supplied": { en: "Flakes, pearls, 50% aqueous solution", az: "Lopa, mirvari, 50% sulu məhlul" },
      "Purity": { en: "96–99% (solids) / 50% (solution)", az: "96–99% (bərk) / 50% (məhlul)" },
      "Appearance": { en: "White hygroscopic flakes or pearls", az: "Ağ hiqroskopik lopa və ya mirvari" },
      "Solubility": { en: "Completely miscible in water (exothermic)", az: "Suda tam həll olur (ekzotermik)" },
    },
    packaging: [
      { en: "25 kg PP bags with PE inner liner (solids)", az: "PE daxili örtüklü 25 kq PP kisələr (bərk)" },
      { en: "1000 kg big bags available on request", az: "Sifarişlə 1000 kq böyük kisələr mövcuddur" },
      { en: "1000 L IBC or 200 L drums for 50% solution", az: "50% məhlul üçün 1000 L IBC və ya 200 L bidonlar" },
      { en: "Shrink-wrapped on pallets for safe handling", az: "Təhlükəsiz daşınma üçün paletlərdə büzüşdürücü örtüklə sarılıb" },
    ],
    shelfLife: { en: "24 months in sealed, dry conditions.", az: "Bağlı və quru şəraitdə 24 ay." },
    storage: {
      en: "Store tightly closed in a cool, dry area. Protect from moisture and CO₂. Keep separated from acids and aluminium.",
      az: "Sərin və quru yerdə möhkəm bağlı saxlayın. Nəmdən və CO₂-dən qoruyun. Turşulardan və alüminiumdan ayrı saxlayın.",
    },
  },
  {
    slug: "sodium-silicate",
    name: { en: "Sodium Silicate", az: "Natrium Silikat" },
    synonym: { en: "Water Glass", az: "Maye şüşə" },
    categories: ["alkalis"],
    summary: {
      en: "Alkaline silicate solution used as a binder, sealant and corrosion inhibitor in water treatment, detergents, drilling and foundry applications.",
      az: "Su təmizləmə, yuyucu vasitələr, qazma və tökmə istehsalında bağlayıcı, izolyasiya və korroziya inhibitoru kimi istifadə olunan qələvi silikat məhlulu.",
    },
    description: {
      en: "Sodium Silicate is a versatile alkaline compound supplied in liquid or solid form. It is used as a binding agent, an adhesive base, a deflocculant in drilling muds and as a corrosion inhibitor in cooling water systems. In water treatment it supports coagulation and protects pipework from corrosion.",
      az: "Natrium silikat maye və ya bərk formada təchiz olunan çoxşaxəli qələvi birləşmədir. Bağlayıcı agent, yapışdırıcı əsası, qazma mayelərində defloklyant və soyutma suyu sistemlərində korroziya inhibitoru kimi istifadə olunur. Su təmizləmədə koaqulyasiyaya kömək edir və boruları korroziyadan qoruyur.",
    },
    spec: {
      "CAS No.": "1344-09-8",
      "HS Code": "2839.19",
      "Chemical Formula": "Na₂SiO₃",
      "Forms Supplied": { en: "Liquid (40–50%) or granular", az: "Maye (40–50%) və ya qranul" },
      "Appearance": {
        en: "Clear to slightly cloudy viscous liquid / white granules",
        az: "Şəffaf və ya bir qədər bulanıq özlü maye / ağ qranullar",
      },
    },
    packaging: [
      { en: "200 L drums or 1000 L IBC for liquid grade", az: "Maye üçün 200 L bidon və ya 1000 L IBC" },
      { en: "25 kg bags for solid grade", az: "Bərk forma üçün 25 kq kisələr" },
    ],
    storage: {
      en: "Keep sealed in a cool, dry location away from acids.",
      az: "Turşulardan uzaq, sərin və quru yerdə bağlı saxlayın.",
    },
  },
  {
    slug: "ferrous-sulfate",
    name: { en: "Ferrous Sulfate", az: "Dəmir (II) Sulfat" },
    synonym: { en: "Iron(II) Sulfate", az: "Dəmir (II) sulfat" },
    categories: ["salts"],
    summary: {
      en: "Iron salt used as a coagulant in water treatment and as a nutrient source in agriculture and animal feed.",
      az: "Su təmizləmədə koaqulyant, kənd təsərrüfatında və heyvan yemində qida mənbəyi kimi istifadə olunan dəmir duzu.",
    },
    description: {
      en: "Ferrous Sulfate is commonly used in municipal and industrial water treatment as an effective coagulant and phosphate-removal agent. It is also applied in soil conditioning, animal feed supplementation and pigment production.",
      az: "Dəmir (II) sulfat bələdiyyə və sənaye su təmizləməsində effektiv koaqulyant və fosfat-aradan qaldırıcı agent kimi geniş istifadə olunur. Həmçinin torpaq yaxşılaşdırılmasında, heyvan yemi əlavələrində və piqment istehsalında tətbiq edilir.",
    },
    spec: {
      "CAS No.": "7720-78-7",
      "HS Code": "2833.29",
      "Chemical Formula": "FeSO₄·7H₂O",
      "Appearance": { en: "Pale green to blue-green crystals", az: "Açıq yaşıldan mavi-yaşıla qədər kristallar" },
      "Purity": "≥ 98%",
    },
    packaging: [
      { en: "25 kg PP bags", az: "25 kq PP kisələr" },
      { en: "1000 kg big bags on request", az: "Sifarişlə 1000 kq böyük kisələr" },
    ],
    storage: {
      en: "Store in a cool, dry area; avoid contact with oxidisers.",
      az: "Sərin və quru yerdə saxlayın; oksidləşdiricilərlə təmasdan çəkinin.",
    },
  },
  {
    slug: "calcium-chloride",
    name: { en: "Calcium Chloride", az: "Kalsium Xlorid" },
    synonym: { en: "CaCl₂", az: "CaCl₂" },
    categories: ["salts"],
    summary: {
      en: "Highly soluble calcium salt used as a completion brine, de-icer, dust suppressant and accelerator in concrete.",
      az: "Tamamlanma duzluğu, buzəritmə vasitəsi, toz tənzimləyici və betonda bərkidici kimi istifadə olunan yüksək həll olan kalsium duzu.",
    },
    description: {
      en: "Calcium Chloride is supplied in flake, pellet and powder form. In oil and gas operations it is used as a workover and completion brine for density control. It is also specified in water treatment, road de-icing, dust control on unpaved surfaces, refrigeration brines and cement acceleration.",
      az: "Kalsium xlorid lopa, peletlər və toz formasında təchiz olunur. Neft və qaz əməliyyatlarında sıxlığa nəzarət üçün təmir və tamamlanma duzluğu kimi istifadə olunur. Həmçinin su təmizləmədə, yol buzəritmədə, asfaltsız səthlərdə toz nəzarətində, soyutma duzluqlarında və sement bərkitməsində tətbiq olunur.",
    },
    spec: {
      "CAS No.": "10043-52-4",
      "HS Code": "2827.20",
      "Chemical Formula": "CaCl₂",
      "Forms Supplied": { en: "Flakes, pellets, powder", az: "Lopa, peletlər, toz" },
      "Purity": { en: "74–94% (depending on grade)", az: "74–94% (dərəcədən asılı olaraq)" },
    },
    packaging: [
      { en: "25 kg PP bags with PE liner", az: "PE örtüklü 25 kq PP kisələr" },
      { en: "1000 kg big bags on request", az: "Sifarişlə 1000 kq böyük kisələr" },
    ],
    storage: {
      en: "Keep dry and tightly sealed; strongly hygroscopic.",
      az: "Quru və möhkəm bağlı saxlayın; güclü hiqroskopikdir.",
    },
  },
  {
    slug: "barit",
    name: { en: "Barite", az: "Barit" },
    synonym: { en: "Barium Sulfate", az: "Barium sulfat" },
    categories: ["salts"],
    summary: {
      en: "High-density weighting agent used to control pressure in drilling muds for oil and gas wells.",
      az: "Neft və qaz quyuları üçün qazma mayelərində təzyiqə nəzarət etmək üçün istifadə olunan yüksək sıxlıqlı ağırlaşdırıcı.",
    },
    description: {
      en: "Barite (Barium Sulfate) is the industry-standard weighting material for drilling fluids. Its high specific gravity allows operators to balance formation pressure and maintain well control, while its inertness prevents unwanted reactions within the fluid system. We supply API-grade Barite meeting specified density and particle distribution requirements.",
      az: "Barit (Barium sulfat) qazma mayeləri üçün sənaye standartı olan ağırlaşdırıcı materialdır. Yüksək xüsusi çəkisi operatorların formasiya təzyiqini balanslaşdırmasına və quyuya nəzarəti saxlamasına imkan verir, inertliyi isə maye sistemində istənməyən reaksiyaların qarşısını alır. Müəyyən edilmiş sıxlıq və hissəcik paylanması tələblərinə cavab verən API dərəcəli Barit təchiz edirik.",
    },
    spec: {
      "CAS No.": "7727-43-7",
      "HS Code": "2511.10",
      "Chemical Formula": "BaSO₄",
      "Specific Gravity": "≥ 4.20 g/cm³ (API)",
      "Appearance": { en: "Off-white to light grey fine powder", az: "Ağımtıl-boz açıq boz incə toz" },
    },
    packaging: [
      { en: "1000 kg big bags", az: "1000 kq böyük kisələr" },
      { en: "Bulk (on request)", az: "Topdan (sifarişlə)" },
    ],
    storage: {
      en: "Store in a dry area; keep packaging intact.",
      az: "Quru yerdə saxlayın; qablaşdırmanı toxunulmaz saxlayın.",
    },
  },
  {
    slug: "hydrochloric-acid",
    name: { en: "Hydrochloric Acid", az: "Xlorid Turşusu" },
    synonym: { en: "HCl", az: "HCl" },
    categories: ["acids"],
    summary: {
      en: "Strong mineral acid used in acidising treatments, pH correction, metal pickling and chemical synthesis.",
      az: "Turşulama əməliyyatlarında, pH tənzimlənməsində, metal təmizlənməsində və kimyəvi sintezdə istifadə olunan güclü mineral turşu.",
    },
    description: {
      en: "Hydrochloric Acid is a highly reactive strong acid used across multiple industries. In oil and gas, it is central to matrix and fracture acidising of carbonate reservoirs. It is also applied in steel pickling, water treatment pH adjustment, ion exchange regeneration and chemical manufacturing.",
      az: "Xlorid turşusu bir çox sənaye sahəsində istifadə olunan yüksək reaktiv güclü turşudur. Neft və qazda karbonat rezervuarlarının matriks və çat turşulandırılmasında əsas rol oynayır. Həmçinin poladın təmizlənməsində, su təmizləmədə pH tənzimlənməsində, ion mübadiləsi bərpasında və kimyəvi istehsalda tətbiq olunur.",
    },
    spec: {
      "CAS No.": "7647-01-0",
      "HS Code": "2806.10",
      "Chemical Formula": "HCl",
      "Concentration": { en: "30–36% aqueous solution", az: "30–36% sulu məhlul" },
      "Appearance": { en: "Clear, colourless to slightly yellow liquid", az: "Şəffaf, rəngsizdən az sarı rəngə qədər maye" },
    },
    packaging: [
      { en: "1000 L IBC", az: "1000 L IBC" },
      { en: "200 L HDPE drums", az: "200 L HDPE bidonlar" },
      { en: "Bulk tank truck", az: "Topdan sisterna ilə" },
    ],
    storage: {
      en: "Store in approved acid-resistant containers in a cool, well-ventilated area away from metals and alkalis.",
      az: "Metallardan və qələvilərdən uzaq, sərin və yaxşı havalandırılan yerdə təsdiqlənmiş turşuya davamlı qablarda saxlayın.",
    },
  },
  {
    slug: "nitric-acid",
    name: { en: "Nitric Acid", az: "Azot Turşusu" },
    synonym: { en: "HNO₃", az: "HNO₃" },
    categories: ["acids"],
    summary: {
      en: "Strong oxidising acid used in fertiliser production, metal processing and chemical synthesis.",
      az: "Gübrə istehsalında, metal emalında və kimyəvi sintezdə istifadə olunan güclü oksidləşdirici turşu.",
    },
    description: {
      en: "Nitric Acid is a powerful oxidising mineral acid. It is a key feedstock for ammonium nitrate fertiliser, is used in metal surface treatment and passivation, and serves as an intermediate across multiple synthetic routes in the chemical industry.",
      az: "Azot turşusu güclü oksidləşdirici mineral turşudur. Ammonium nitrat gübrəsi üçün əsas xammaldır, metal səthinin emalı və passivləşdirilməsində istifadə olunur və kimya sənayesində bir çox sintetik yolda aralıq maddə kimi xidmət edir.",
    },
    spec: {
      "CAS No.": "7697-37-2",
      "HS Code": "2808.00",
      "Chemical Formula": "HNO₃",
      "Concentration": { en: "57–68% aqueous solution", az: "57–68% sulu məhlul" },
      "Appearance": { en: "Clear, colourless to pale yellow liquid", az: "Şəffaf, rəngsizdən açıq sarıya qədər maye" },
    },
    packaging: [
      { en: "1000 L IBC (acid-grade)", az: "1000 L IBC (turşu dərəcəli)" },
      { en: "Bulk on request", az: "Sifarişlə topdan" },
    ],
    storage: {
      en: "Store separately from organic materials and reducing agents in corrosion-resistant containers.",
      az: "Üzvi materiallardan və reduksiyaedicilərdən ayrı, korroziyaya davamlı qablarda saxlayın.",
    },
  },
  {
    slug: "sulfuric-acid",
    name: { en: "Sulfuric Acid", az: "Sulfat Turşusu" },
    synonym: { en: "H₂SO₄", az: "H₂SO₄" },
    categories: ["acids"],
    summary: {
      en: "One of the most widely used industrial acids — essential to fertilisers, batteries, water treatment and chemical processing.",
      az: "Ən geniş istifadə olunan sənaye turşularından biri — gübrələr, akkumulyatorlar, su təmizləmə və kimyəvi emal üçün vacibdir.",
    },
    description: {
      en: "Sulfuric Acid is a highly corrosive strong acid used in fertiliser manufacturing, lead-acid battery production, metal processing, pH control in water and effluent treatment, and as a reagent in many chemical syntheses. Supplied in both technical and battery grades.",
      az: "Sulfat turşusu gübrə istehsalında, qurğuşun-turşu akkumulyatorların hazırlanmasında, metal emalında, su və tullantı sularının təmizlənməsində pH nəzarətində və bir çox kimyəvi sintezdə reagent kimi istifadə olunan yüksək korroziv güclü turşudur. Həm texniki, həm də akkumulyator dərəcəli formada təchiz olunur.",
    },
    spec: {
      "CAS No.": "7664-93-9",
      "HS Code": "2807.00",
      "Chemical Formula": "H₂SO₄",
      "Concentration": "94–98%",
      "Appearance": { en: "Clear, colourless, oily liquid", az: "Şəffaf, rəngsiz, yağlı maye" },
    },
    packaging: [
      { en: "1000 L IBC", az: "1000 L IBC" },
      { en: "Tank truck", az: "Sisterna" },
    ],
    storage: {
      en: "Store in acid-resistant containers away from water, metals and organic substances.",
      az: "Sudan, metallardan və üzvi maddələrdən uzaq, turşuya davamlı qablarda saxlayın.",
    },
  },
  {
    slug: "sodium-chloride",
    name: { en: "Sodium Chloride", az: "Natrium Xlorid" },
    synonym: { en: "Industrial Salt", az: "Sənaye duzu" },
    categories: ["salts"],
    summary: {
      en: "Technical and food-grade salt used in brines, ion exchange, food processing and feed supplementation.",
      az: "Duzluqlarda, ion mübadiləsində, qida emalında və yem əlavələrində istifadə olunan texniki və qida dərəcəli duz.",
    },
    description: {
      en: "Sodium Chloride is supplied in multiple grades — technical, water-softening and food-grade. It is used in completion brines, water softener regeneration, road de-icing, food preservation and animal feed formulations.",
      az: "Natrium xlorid bir neçə dərəcədə təchiz olunur — texniki, su yumşaltma və qida dərəcəli. Tamamlanma duzluqlarında, su yumşaldıcıların bərpasında, yol buzəritməsində, qida konservasiyasında və heyvan yemi formulalarında istifadə olunur.",
    },
    spec: {
      "CAS No.": "7647-14-5",
      "HS Code": "2501.00",
      "Chemical Formula": "NaCl",
      "Purity": { en: "≥ 98% (technical) / ≥ 99.5% (food-grade)", az: "≥ 98% (texniki) / ≥ 99.5% (qida dərəcəli)" },
      "Appearance": { en: "White crystalline powder", az: "Ağ kristal toz" },
    },
    packaging: [
      { en: "25 kg PP bags", az: "25 kq PP kisələr" },
      { en: "1000 kg big bags", az: "1000 kq böyük kisələr" },
    ],
    storage: {
      en: "Store in a dry, well-ventilated area.",
      az: "Quru, yaxşı havalandırılan yerdə saxlayın.",
    },
  },
  {
    slug: "potassium-chloride",
    name: { en: "Potassium Chloride", az: "Kalium Xlorid" },
    synonym: { en: "KCl", az: "KCl" },
    categories: ["salts"],
    summary: {
      en: "Potassium salt used in drilling fluids, fertilisers and pharmaceutical formulations.",
      az: "Qazma mayelərində, gübrələrdə və əczaçılıq formulalarında istifadə olunan kalium duzu.",
    },
    description: {
      en: "Potassium Chloride is specified in shale-inhibitive drilling fluids where it stabilises clays and reduces swelling. It is also a major source of potassium in fertilisers and is used in food, pharmaceutical and industrial applications.",
      az: "Kalium xlorid şistin şişməsinin qarşısını alan qazma mayelərində istifadə olunur, gil minerallarını sabitləşdirir və şişməni azaldır. Həmçinin gübrələrdə kaliumun əsas mənbəyidir və qida, əczaçılıq və sənaye sahələrində tətbiq olunur.",
    },
    spec: {
      "CAS No.": "7447-40-7",
      "HS Code": "3104.20",
      "Chemical Formula": "KCl",
      "Purity": "≥ 98%",
      "Appearance": { en: "White to off-white crystals", az: "Ağdan ağımtıla qədər kristallar" },
    },
    packaging: [
      { en: "25 kg bags", az: "25 kq kisələr" },
      { en: "1000 kg big bags", az: "1000 kq böyük kisələr" },
    ],
    storage: {
      en: "Keep in sealed packaging in a dry environment.",
      az: "Quru mühitdə bağlı qablaşdırmada saxlayın.",
    },
  },
  {
    slug: "sodium-carbonate",
    name: { en: "Sodium Carbonate", az: "Natrium Karbonat" },
    synonym: { en: "Soda Ash", az: "Kalsinasiya olunmuş soda" },
    categories: ["alkalis"],
    summary: {
      en: "Versatile alkali used in glass, detergents, pulp and paper, and pH correction in water treatment.",
      az: "Şüşə, yuyucu vasitələr, sellüloz və kağız istehsalında və su təmizləmədə pH tənzimlənməsində istifadə olunan çoxşaxəli qələvi.",
    },
    description: {
      en: "Sodium Carbonate (Soda Ash) is a large-volume industrial alkali. It is used in glass manufacturing, detergents, pulp and paper processing, water softening and general pH regulation in process water systems.",
      az: "Natrium karbonat (Kalsinasiya olunmuş soda) böyük həcmli sənaye qələvisidir. Şüşə istehsalında, yuyucu vasitələrdə, sellüloz və kağız emalında, su yumşaltmada və proses suyu sistemlərində ümumi pH tənzimlənməsində istifadə olunur.",
    },
    spec: {
      "CAS No.": "497-19-8",
      "HS Code": "2836.20",
      "Chemical Formula": "Na₂CO₃",
      "Purity": "≥ 99.2%",
      "Appearance": { en: "White granular or powdered solid", az: "Ağ qranul və ya tozvari bərk maddə" },
    },
    packaging: [
      { en: "25 kg PP bags", az: "25 kq PP kisələr" },
      { en: "1000 kg big bags", az: "1000 kq böyük kisələr" },
    ],
    storage: {
      en: "Store in a cool, dry area; protect from moisture.",
      az: "Sərin və quru yerdə saxlayın; nəmdən qoruyun.",
    },
  },
  {
    slug: "ascorbic-acid",
    name: { en: "Ascorbic Acid", az: "Askorbin Turşusu" },
    synonym: { en: "Vitamin C", az: "Vitamin C" },
    categories: ["acids"],
    summary: {
      en: "Food-grade antioxidant and acidulant used across beverage, meat processing, bakery and feed applications.",
      az: "İçki, ət emalı, çörək-bulka və yem sahələrində istifadə olunan qida dərəcəli antioksidant və turşulaşdırıcı.",
    },
    description: {
      en: "Ascorbic Acid is used as an antioxidant, flavour enhancer and vitamin fortifier in food and feed. Typical applications include beverages, cured meats, bakery improvers, fruit preservation and nutritional supplementation.",
      az: "Askorbin turşusu qidada və yemdə antioksidant, dad gücləndiricisi və vitamin zənginləşdiricisi kimi istifadə olunur. Tipik tətbiqlərə içkilər, duzlanmış ət məhsulları, çörək-bulka üçün yaxşılaşdırıcılar, meyvə konservasiyası və qida əlavələri daxildir.",
    },
    spec: {
      "CAS No.": "50-81-7",
      "HS Code": "2936.27",
      "Chemical Formula": "C₆H₈O₆",
      "Purity": "≥ 99%",
      "Appearance": { en: "White to light yellow crystalline powder", az: "Ağdan açıq sarıya qədər kristal toz" },
    },
    packaging: [
      { en: "25 kg fibre drums", az: "25 kq lifli bidonlar" },
      { en: "25 kg cartons with PE liner", az: "PE örtüklü 25 kq karton qutular" },
    ],
    storage: {
      en: "Store in a cool, dry area away from light.",
      az: "İşıqdan uzaq, sərin və quru yerdə saxlayın.",
    },
  },
  {
    slug: "citric-acid",
    name: { en: "Citric Acid", az: "Limon Turşusu" },
    synonym: { en: "Anhydrous / Monohydrate", az: "Susuz / Monohidrat" },
    categories: ["acids"],
    summary: {
      en: "Food-grade organic acid used as an acidulant, preservative and chelating agent.",
      az: "Turşulaşdırıcı, konservant və xelat əmələ gətirən agent kimi istifadə olunan qida dərəcəli üzvi turşu.",
    },
    description: {
      en: "Citric Acid is widely used in soft drinks, confectionery, dairy, canned food and cleaning products. It provides a clean tart flavour, stabilises pH, sequesters metal ions and extends shelf life.",
      az: "Limon turşusu sərinləşdirici içkilərdə, qənnadı məmulatlarında, süd məhsullarında, konservləşdirilmiş qida və təmizlik məhsullarında geniş istifadə olunur. Təmiz turş dad verir, pH-ı sabitləşdirir, metal ionlarını bağlayır və saxlama müddətini uzadır.",
    },
    spec: {
      "CAS No.": "77-92-9",
      "HS Code": "2918.14",
      "Chemical Formula": "C₆H₈O₇",
      "Purity": "≥ 99.5%",
      "Appearance": { en: "Colourless to white crystalline powder", az: "Rəngsizdən ağa qədər kristal toz" },
    },
    packaging: [
      { en: "25 kg PP bags", az: "25 kq PP kisələr" },
      { en: "1000 kg big bags", az: "1000 kq böyük kisələr" },
    ],
    storage: {
      en: "Store in a dry area; avoid high humidity.",
      az: "Quru yerdə saxlayın; yüksək rütubətdən qorunun.",
    },
  },
  {
    slug: "lactic-acid",
    name: { en: "Lactic Acid", az: "Süd Turşusu" },
    categories: ["acids"],
    summary: {
      en: "Mild organic acid used for acidification, preservation and flavour in food and feed production.",
      az: "Qida və yem istehsalında turşulaşdırma, konservasiya və dad üçün istifadə olunan yumşaq üzvi turşu.",
    },
    description: {
      en: "Lactic Acid is a naturally occurring organic acid used as an acidulant, preservative and flavour modulator. Typical applications include dairy, fermented beverages, meat processing, bakery and silage additives.",
      az: "Süd turşusu təbii mövcud olan üzvi turşu olub, turşulaşdırıcı, konservant və dad modulyatoru kimi istifadə olunur. Tipik tətbiqlərə süd məhsulları, fermentasiya olunmuş içkilər, ət emalı, çörək-bulka və silos əlavələri daxildir.",
    },
    spec: {
      "CAS No.": "79-33-4",
      "HS Code": "2918.11",
      "Chemical Formula": "C₃H₆O₃",
      "Concentration": { en: "80% / 88% aqueous solution", az: "80% / 88% sulu məhlul" },
      "Appearance": { en: "Clear colourless to light yellow liquid", az: "Şəffaf rəngsizdən açıq sarıya qədər maye" },
    },
    packaging: [
      { en: "25 kg jerrycan", az: "25 kq kanistr" },
      { en: "200 kg drum", az: "200 kq bidon" },
      { en: "1000 kg IBC", az: "1000 kq IBC" },
    ],
    storage: {
      en: "Store in a cool, dry area in original packaging.",
      az: "Orijinal qablaşdırmada sərin və quru yerdə saxlayın.",
    },
  },
  {
    slug: "phosphoric-acid",
    name: { en: "Phosphoric Acid", az: "Fosfor Turşusu" },
    synonym: { en: "H₃PO₄", az: "H₃PO₄" },
    categories: ["acids"],
    summary: {
      en: "Food-grade acid used in beverages, cheese products, feed supplementation and surface treatment.",
      az: "İçkilərdə, pendir məhsullarında, yem əlavələrində və səth emalında istifadə olunan qida dərəcəli turşu.",
    },
    description: {
      en: "Phosphoric Acid is supplied in food and technical grades. It is used for acidifying beverages and processed foods, in feed phosphate production, and in metal surface preparation for coatings.",
      az: "Fosfor turşusu qida və texniki dərəcələrdə təchiz olunur. İçkilərin və emal olunmuş qidaların turşulaşdırılması, yem fosfatı istehsalı və örtüklər üçün metal səthlərinin hazırlanmasında istifadə olunur.",
    },
    spec: {
      "CAS No.": "7664-38-2",
      "HS Code": "2809.20",
      "Chemical Formula": "H₃PO₄",
      "Concentration": "75–85%",
      "Appearance": { en: "Clear, viscous, colourless liquid", az: "Şəffaf, özlü, rəngsiz maye" },
    },
    packaging: [
      { en: "35 kg jerrycans", az: "35 kq kanistrlər" },
      { en: "200 kg drums", az: "200 kq bidonlar" },
      { en: "IBC 1000 L", az: "1000 L IBC" },
    ],
    storage: {
      en: "Store in corrosion-resistant containers in a cool, dry place.",
      az: "Sərin və quru yerdə korroziyaya davamlı qablarda saxlayın.",
    },
  },
  {
    slug: "potassium-sorbate",
    name: { en: "Potassium Sorbate", az: "Kalium Sorbat" },
    categories: ["salts"],
    summary: {
      en: "Widely used food-grade preservative effective against moulds, yeasts and some bacteria.",
      az: "Kif, maya və bəzi bakteriyalara qarşı effektiv olan geniş istifadə olunan qida dərəcəli konservant.",
    },
    description: {
      en: "Potassium Sorbate is the potassium salt of sorbic acid. It provides effective preservation in cheese, wine, baked goods, dried fruit, beverages and personal care products while maintaining a clean flavour profile.",
      az: "Kalium sorbat sorbat turşusunun kalium duzudur. Pendir, şərab, çörək məmulatları, qurudulmuş meyvə, içkilər və şəxsi qulluq məhsullarında effektiv konservasiya təmin edir və təmiz dad profili saxlayır.",
    },
    spec: {
      "CAS No.": "24634-61-5",
      "HS Code": "2916.19",
      "Chemical Formula": "C₆H₇KO₂",
      "Purity": "≥ 99%",
      "Appearance": { en: "White to off-white granules or powder", az: "Ağdan ağımtıla qədər qranul və ya toz" },
    },
    packaging: [{ en: "25 kg cartons with PE liner", az: "PE örtüklü 25 kq karton qutular" }],
    storage: {
      en: "Keep dry and away from direct sunlight.",
      az: "Quru və birbaşa günəş işığından uzaqda saxlayın.",
    },
  },
  {
    slug: "sodium-benzoate",
    name: { en: "Sodium Benzoate", az: "Natrium Benzoat" },
    categories: ["salts"],
    summary: {
      en: "Common food preservative active against a broad range of microorganisms in acidic systems.",
      az: "Turş sistemlərdə geniş mikroorqanizm spektrinə qarşı aktiv olan yayılmış qida konservantı.",
    },
    description: {
      en: "Sodium Benzoate is a widely specified preservative used in carbonated drinks, fruit juices, pickles, sauces and condiments. It performs optimally at pH below 4.5 and contributes to longer shelf life without affecting flavour at normal use levels.",
      az: "Natrium benzoat qazlı içkilərdə, meyvə şirələrində, turşularda, souslarda və ədviyyatlarda istifadə olunan geniş yayılmış konservantdır. 4.5-dən aşağı pH-da optimal işləyir və normal istifadə səviyyələrində dada təsir etmədən daha uzun saxlama müddəti təmin edir.",
    },
    spec: {
      "CAS No.": "532-32-1",
      "HS Code": "2916.31",
      "Chemical Formula": "C₇H₅NaO₂",
      "Purity": "≥ 99%",
      "Appearance": { en: "White crystalline powder or granules", az: "Ağ kristal toz və ya qranullar" },
    },
    packaging: [{ en: "25 kg PP bags with PE liner", az: "PE örtüklü 25 kq PP kisələr" }],
    storage: {
      en: "Store in a cool, dry, well-ventilated area.",
      az: "Sərin, quru və yaxşı havalandırılan yerdə saxlayın.",
    },
  },
  {
    slug: "isopropyl-alcohol",
    name: { en: "Isopropyl Alcohol", az: "İzopropil Spirti" },
    synonym: { en: "IPA", az: "IPA" },
    categories: ["solvents"],
    summary: {
      en: "High-purity solvent used in electronics cleaning, printing, pharmaceutical and cosmetic formulations.",
      az: "Elektronika təmizliyində, çapda, əczaçılıq və kosmetik formulalarda istifadə olunan yüksək saflıqlı həlledici.",
    },
    description: {
      en: "Isopropyl Alcohol is a fast-evaporating, low-residue solvent. It is widely specified for cleaning electronic assemblies and precision optics, as a carrier in printing and coating, and as a solvent in pharmaceutical and cosmetic production.",
      az: "İzopropil spirti tez buxarlanan, aşağı qalıqlı həlledicidir. Elektron qurğuların və dəqiq optikanın təmizlənməsində, çap və örtük sahəsində daşıyıcı kimi, əczaçılıq və kosmetik istehsalda həlledici kimi geniş istifadə olunur.",
    },
    spec: {
      "CAS No.": "67-63-0",
      "HS Code": "2905.12",
      "Chemical Formula": "C₃H₈O",
      "Purity": "≥ 99.9%",
      "Appearance": { en: "Clear, colourless liquid", az: "Şəffaf, rəngsiz maye" },
    },
    packaging: [
      { en: "160 kg drums", az: "160 kq bidonlar" },
      { en: "1000 L IBC", az: "1000 L IBC" },
    ],
    storage: {
      en: "Store in a cool, well-ventilated area away from ignition sources and oxidisers.",
      az: "Alovlanma mənbələrindən və oksidləşdiricilərdən uzaq, sərin və yaxşı havalandırılan yerdə saxlayın.",
    },
  },
  {
    slug: "dichloroethane",
    name: { en: "Dichloroethane", az: "Dixloretan" },
    synonym: { en: "EDC", az: "EDC" },
    categories: ["solvents"],
    summary: {
      en: "Chlorinated solvent used as a feedstock for vinyl chloride and as an industrial degreaser.",
      az: "Vinil xloridin istehsalı üçün xammal və sənaye yağsızlaşdırıcısı kimi istifadə olunan xlorlu həlledici.",
    },
    description: {
      en: "1,2-Dichloroethane is a key intermediate in the production of vinyl chloride monomer (VCM) and is also applied as a solvent for resins, waxes, rubber and as a degreasing agent in metal processing.",
      az: "1,2-Dixloretan vinil xlorid monomerinin (VCM) istehsalında əsas aralıq məhsuldur, həmçinin qatranlar, mumlar, rezin üçün həlledici və metal emalında yağsızlaşdırıcı agent kimi tətbiq olunur.",
    },
    spec: {
      "CAS No.": "107-06-2",
      "HS Code": "2903.15",
      "Chemical Formula": "C₂H₄Cl₂",
      "Purity": "≥ 99.5%",
      "Appearance": { en: "Clear colourless liquid", az: "Şəffaf rəngsiz maye" },
    },
    packaging: [
      { en: "250 kg drums", az: "250 kq bidonlar" },
      { en: "Bulk ISO tank", az: "Topdan ISO çən" },
    ],
    storage: {
      en: "Store in sealed containers in a cool, ventilated area, away from oxidisers and ignition sources.",
      az: "Oksidləşdiricilərdən və alovlanma mənbələrindən uzaq, sərin, havalandırılan yerdə bağlı qablarda saxlayın.",
    },
  },
  {
    slug: "trichloroethylene",
    name: { en: "Trichloroethylene", az: "Trixloretilen" },
    synonym: { en: "TCE", az: "TCE" },
    categories: ["solvents"],
    summary: {
      en: "Non-flammable chlorinated solvent used for metal degreasing and specialty extraction.",
      az: "Metal yağsızlaşdırmada və xüsusi ekstraksiyada istifadə olunan alovlanmayan xlorlu həlledici.",
    },
    description: {
      en: "Trichloroethylene is a high-performance non-flammable solvent used in vapour and cold metal degreasing, textile cleaning and as an extraction medium in specific industrial processes.",
      az: "Trixloretilen buxar və soyuq metal yağsızlaşdırmada, toxuculuq təmizliyində və müəyyən sənaye proseslərində ekstraksiya mühiti kimi istifadə olunan yüksək performanslı alovlanmayan həlledicidir.",
    },
    spec: {
      "CAS No.": "79-01-6",
      "HS Code": "2903.22",
      "Chemical Formula": "C₂HCl₃",
      "Purity": "≥ 99.5%",
      "Appearance": { en: "Clear colourless liquid with characteristic odour", az: "Xarakterik iyli şəffaf rəngsiz maye" },
    },
    packaging: [
      { en: "250 kg drums", az: "250 kq bidonlar" },
      { en: "Bulk on request", az: "Sifarişlə topdan" },
    ],
    storage: {
      en: "Store in tightly closed containers in a cool, well-ventilated area.",
      az: "Sərin və yaxşı havalandırılan yerdə möhkəm bağlı qablarda saxlayın.",
    },
  },

  // ── Additional Chemicals ────────────────────────────────────────────────
  {
    slug: "hydrogen-peroxide",
    name: { en: "Hydrogen Peroxide", az: "Hidrogen Peroksid" },
    synonym: { en: "H₂O₂", az: "H₂O₂" },
    categories: ["oxidizing-agents"],
    summary: {
      en: "Strong oxidising agent used in water treatment, disinfection, bleaching and chemical synthesis.",
      az: "Su təmizləmə, dezinfeksiya, ağartma və kimyəvi sintezdə istifadə olunan güclü oksidləşdirici agent.",
    },
    description: {
      en: "Hydrogen Peroxide is a powerful, environmentally friendly oxidiser that decomposes to water and oxygen. It is widely specified for disinfection, sulphide and odour control in wastewater, textile and pulp bleaching, and as an intermediate in chemical manufacturing.",
      az: "Hidrogen peroksid suya və oksigenə parçalanan, ətraf mühit üçün təhlükəsiz güclü oksidləşdiricidir. Dezinfeksiya, tullantı sularında sulfid və iy nəzarəti, toxuculuq və sellüloz ağartması və kimyəvi istehsalda aralıq maddə kimi geniş istifadə olunur.",
    },
    spec: {
      "CAS No.": "7722-84-1",
      "HS Code": "2847.00",
      "Chemical Formula": "H₂O₂",
      "Concentration": { en: "35% / 50% aqueous solution", az: "35% / 50% sulu məhlul" },
      "Appearance": { en: "Clear, colourless liquid", az: "Şəffaf, rəngsiz maye" },
    },
    packaging: [
      { en: "30 kg HDPE jerrycans", az: "30 kq HDPE kanistrlər" },
      { en: "200 L vented drums", az: "200 L havalandırma vintilli bidonlar" },
      { en: "1000 L IBC", az: "1000 L IBC" },
    ],
    storage: {
      en: "Store in vented HDPE containers, away from heat, metals and combustibles.",
      az: "Havalandırılan HDPE qablarda, istidən, metallardan və yanan maddələrdən uzaq saxlayın.",
    },
  },
  {
    slug: "perchloric-acid",
    name: { en: "Perchloric Acid", az: "Perxlorat Turşusu" },
    synonym: { en: "HClO₄", az: "HClO₄" },
    categories: ["acids"],
    summary: {
      en: "Strong oxidising mineral acid used in analytical chemistry, electroplating and specialty synthesis.",
      az: "Analitik kimyada, qalvanik örtüklərdə və xüsusi sintezdə istifadə olunan güclü oksidləşdirici mineral turşu.",
    },
    description: {
      en: "Perchloric Acid is one of the strongest mineral acids and a powerful oxidiser at elevated concentrations. It is specified in analytical sample preparation, electropolishing, and as a reagent in the manufacture of perchlorates and specialty intermediates.",
      az: "Perxlorat turşusu ən güclü mineral turşulardan biri və yüksək qatılıqlarda güclü oksidləşdiricidir. Analitik nümunə hazırlığında, elektrocilada və perxloratların və xüsusi aralıq maddələrin istehsalında reagent kimi istifadə olunur.",
    },
    spec: {
      "CAS No.": "7601-90-3",
      "HS Code": "2811.22",
      "Chemical Formula": "HClO₄",
      "Concentration": { en: "60–70% aqueous solution", az: "60–70% sulu məhlul" },
      "Appearance": { en: "Clear, colourless liquid", az: "Şəffaf, rəngsiz maye" },
    },
    packaging: [
      { en: "2.5 L / 25 L glass bottles", az: "2.5 L / 25 L şüşə şüşələr" },
      { en: "Acid-resistant drums on request", az: "Sifarişlə turşuya davamlı bidonlar" },
    ],
    storage: {
      en: "Store away from organic materials, reducing agents and heat sources in acid-resistant containers.",
      az: "Üzvi materiallardan, reduksiyaedicilərdən və istilik mənbələrindən uzaq, turşuya davamlı qablarda saxlayın.",
    },
  },
  {
    slug: "calcium-hypochlorite",
    name: { en: "Calcium Hypochlorite", az: "Kalsium Hipoxlorit" },
    synonym: { en: "Ca(ClO)₂", az: "Ca(ClO)₂" },
    categories: ["oxidizing-agents"],
    summary: {
      en: "Stable chlorine-based oxidiser used for water disinfection, sanitation and bleaching.",
      az: "Su dezinfeksiyası, sanitar təmizlik və ağartma üçün istifadə olunan sabit xlor əsaslı oksidləşdirici.",
    },
    description: {
      en: "Calcium Hypochlorite is supplied as granules or tablets with high available chlorine content. It is the industry-standard solid chlorine source for drinking water, swimming pools, sanitation in food and dairy plants, and general industrial disinfection.",
      az: "Kalsium hipoxlorit yüksək aktiv xlor tərkibli qranul və ya həblər şəklində təchiz olunur. İçməli su, üzgüçülük hovuzları, qida və süd müəssisələrində sanitar təmizlik və ümumi sənaye dezinfeksiyası üçün sənaye standartı olan bərk xlor mənbəyidir.",
    },
    spec: {
      "CAS No.": "7778-54-3",
      "HS Code": "2828.10",
      "Chemical Formula": "Ca(ClO)₂",
      "Purity": { en: "65–70% available chlorine", az: "65–70% aktiv xlor" },
      "Appearance": { en: "White granules or tablets", az: "Ağ qranullar və ya həblər" },
    },
    packaging: [
      { en: "25 kg / 45 kg HDPE drums", az: "25 kq / 45 kq HDPE bidonlar" },
      { en: "5 kg pails for retail/pool use", az: "Pərakəndə/hovuz istifadəsi üçün 5 kq vedrələr" },
    ],
    storage: {
      en: "Store in a cool, dry, well-ventilated area, away from organic and combustible materials.",
      az: "Üzvi və yanan maddələrdən uzaq, sərin, quru və yaxşı havalandırılan yerdə saxlayın.",
    },
  },
  {
    slug: "ferric-chloride",
    name: { en: "Ferric Chloride", az: "Dəmir (III) Xlorid" },
    synonym: { en: "Iron(III) Chloride", az: "Dəmir (III) xlorid" },
    categories: ["salts"],
    summary: {
      en: "Effective coagulant for municipal and industrial water and wastewater treatment.",
      az: "Bələdiyyə və sənaye su və tullantı sularının təmizlənməsi üçün effektiv koaqulyant.",
    },
    description: {
      en: "Ferric Chloride is a high-performance coagulant used for phosphate removal, sludge conditioning, odour control and turbidity reduction. Also applied in PCB etching, pigment production and as a chemical intermediate.",
      az: "Dəmir (III) xlorid fosfat təmizlənməsi, lil emalı, iy nəzarəti və bulanıqlıq azaldılması üçün istifadə olunan yüksək performanslı koaqulyantdır. Həmçinin PCB qravürası, piqment istehsalı və kimyəvi aralıq maddə kimi tətbiq olunur.",
    },
    spec: {
      "CAS No.": "7705-08-0",
      "HS Code": "2827.39",
      "Chemical Formula": "FeCl₃",
      "Concentration": { en: "40% aqueous solution / anhydrous solid", az: "40% sulu məhlul / susuz bərk" },
      "Appearance": { en: "Dark brown viscous liquid or yellow-brown crystals", az: "Tünd qəhvəyi özlü maye və ya sarı-qəhvəyi kristallar" },
    },
    packaging: [
      { en: "1000 L IBC for solution", az: "Məhlul üçün 1000 L IBC" },
      { en: "25 kg bags for solid grade", az: "Bərk forma üçün 25 kq kisələr" },
    ],
    storage: {
      en: "Store in corrosion-resistant containers; protect from sunlight and freezing.",
      az: "Korroziyaya davamlı qablarda saxlayın; günəş işığından və donmadan qoruyun.",
    },
  },
  {
    slug: "sodium-sulfide",
    name: { en: "Sodium Sulfide", az: "Natrium Sulfid" },
    synonym: { en: "Na₂S", az: "Na₂S" },
    categories: ["sulfides"],
    summary: {
      en: "Industrial sulfide used in mining flotation, leather processing, dyes and water treatment.",
      az: "Mədən flotasiyası, dəri emalı, boyaqlar və su təmizləmədə istifadə olunan sənaye sulfidi.",
    },
    description: {
      en: "Sodium Sulfide is a versatile reagent used in mineral flotation (lead-zinc-copper ores), leather depilation, sulphur dye intermediates, and the precipitation of heavy metals from process and effluent streams.",
      az: "Natrium sulfid mineral flotasiyasında (qurğuşun-sink-mis filizləri), dəri tükdənləşdirmədə, kükürd boyaq aralıq məhsullarında və proses və tullantı axınlarından ağır metalların çökdürülməsində istifadə olunan çoxşaxəli reagentdir.",
    },
    spec: {
      "CAS No.": "1313-82-2",
      "HS Code": "2830.10",
      "Chemical Formula": "Na₂S",
      "Purity": { en: "60–62% (flakes)", az: "60–62% (lopa)" },
      "Appearance": { en: "Yellow to red-brown flakes", az: "Sarıdan qırmızı-qəhvəyiyə qədər lopa" },
    },
    packaging: [
      { en: "25 kg PP bags with PE liner", az: "PE örtüklü 25 kq PP kisələr" },
      { en: "1000 kg big bags on request", az: "Sifarişlə 1000 kq böyük kisələr" },
    ],
    storage: {
      en: "Keep dry and sealed; avoid contact with acids (releases toxic H₂S).",
      az: "Quru və bağlı saxlayın; turşularla təmasdan çəkinin (zəhərli H₂S buraxır).",
    },
  },
  {
    slug: "zinc-sulfate",
    name: { en: "Zinc Sulfate", az: "Sink Sulfat" },
    synonym: { en: "ZnSO₄·7H₂O", az: "ZnSO₄·7H₂O" },
    categories: ["salts"],
    summary: {
      en: "Zinc salt used in fertilisers, animal feed, electroplating and pharmaceutical applications.",
      az: "Gübrələrdə, heyvan yemində, qalvanik örtüklərdə və əczaçılıq tətbiqlərində istifadə olunan sink duzu.",
    },
    description: {
      en: "Zinc Sulfate is a primary source of supplemental zinc. It is used as a micronutrient in fertilisers, an essential mineral in feed premixes, an electrolyte in zinc plating baths, and a reagent in pharmaceutical and chemical manufacturing.",
      az: "Sink sulfat əlavə sinkin əsas mənbəyidir. Gübrələrdə mikroqida, yem premikslərində vacib mineral, sink örtük hamamlarında elektrolit və əczaçılıq və kimyəvi istehsalda reagent kimi istifadə olunur.",
    },
    spec: {
      "CAS No.": "7446-20-0",
      "HS Code": "2833.29",
      "Chemical Formula": "ZnSO₄·7H₂O",
      "Purity": "≥ 99%",
      "Appearance": { en: "White to colourless crystalline solid", az: "Ağdan rəngsizə qədər kristal bərk maddə" },
    },
    packaging: [
      { en: "25 kg PP bags", az: "25 kq PP kisələr" },
      { en: "1000 kg big bags on request", az: "Sifarişlə 1000 kq böyük kisələr" },
    ],
    storage: {
      en: "Store in a cool, dry area; protect from humidity.",
      az: "Sərin və quru yerdə saxlayın; rütubətdən qoruyun.",
    },
  },
  {
    slug: "sodium-bicarbonate",
    name: { en: "Sodium Bicarbonate", az: "Natrium Hidrokarbonat" },
    synonym: { en: "Baking Soda / NaHCO₃", az: "Çörək sodası / NaHCO₃" },
    categories: ["salts"],
    summary: {
      en: "Mild alkaline salt used in food, pharmaceuticals, water treatment and flue-gas neutralisation.",
      az: "Qida, əczaçılıq, su təmizləmə və tüstü qazlarının neytrallaşdırılmasında istifadə olunan yumşaq qələvi duz.",
    },
    description: {
      en: "Sodium Bicarbonate is a multi-purpose alkaline salt supplied in food, technical and pharma grades. Used in bakery, beverage production, antacid formulations, dialysis solutions, fire-extinguishing powders and dry sorbent injection for flue-gas treatment.",
      az: "Natrium hidrokarbonat qida, texniki və əczaçılıq dərəcələrində təchiz olunan çoxməqsədli qələvi duzdur. Çörək-bulka, içki istehsalı, antasid formulalar, dializ məhlulları, yanğınsöndürən tozlar və tüstü qazı təmizlənməsi üçün quru sorbent inyeksiyasında istifadə olunur.",
    },
    spec: {
      "CAS No.": "144-55-8",
      "HS Code": "2836.30",
      "Chemical Formula": "NaHCO₃",
      "Purity": "≥ 99%",
      "Appearance": { en: "White crystalline powder", az: "Ağ kristal toz" },
    },
    packaging: [
      { en: "25 kg PP bags", az: "25 kq PP kisələr" },
      { en: "1000 kg big bags", az: "1000 kq böyük kisələr" },
    ],
    storage: {
      en: "Store in a dry, well-ventilated area; protect from moisture and acids.",
      az: "Quru və yaxşı havalandırılan yerdə saxlayın; nəmdən və turşulardan qoruyun.",
    },
  },
  {
    slug: "laprol",
    name: { en: "Laprol", az: "Laprol" },
    synonym: { en: "Polyether Polyol", az: "Poliefir Poliol" },
    categories: ["polyols-additives"],
    summary: {
      en: "Polyether polyol used in polyurethane production, oilfield demulsifiers and specialty formulations.",
      az: "Poliuretan istehsalında, neft mədəni demulsifikatorlarında və xüsusi formulalarda istifadə olunan poliefir polioldur.",
    },
    description: {
      en: "Laprol is a family of polyether polyols supplied in different molecular weights and functionalities. Typical applications include flexible and rigid polyurethane foams, elastomers, adhesives, sealants, and as base components in oilfield demulsifiers and lubricant formulations.",
      az: "Laprol müxtəlif molekulyar çəkilərdə və funksionallıqlarda təchiz olunan poliefir poliollar ailəsidir. Tipik tətbiqlərə elastik və sərt poliuretan köpüklər, elastomerlər, yapışdırıcılar, sızdırmazlıq vasitələri və neft mədəni demulsifikatorlarında və sürtkü formulalarında əsas komponentlər daxildir.",
    },
    spec: {
      "Forms Supplied": { en: "Liquid polyol grades (e.g. 2502, 3603, 5003)", az: "Maye poliol dərəcələri (məs. 2502, 3603, 5003)" },
      "Appearance": { en: "Clear to light yellow viscous liquid", az: "Şəffafdan açıq sarıya qədər özlü maye" },
    },
    packaging: [
      { en: "200 kg steel drums", az: "200 kq polad bidonlar" },
      { en: "1000 kg IBC", az: "1000 kq IBC" },
    ],
    storage: {
      en: "Store in sealed containers in a cool, dry area; protect from moisture.",
      az: "Sərin və quru yerdə bağlı qablarda saxlayın; nəmdən qoruyun.",
    },
  },
  {
    slug: "surfactant-emulsifier-4745",
    name: { en: "Surfactant / Emulsifier 4745", az: "Səthi-aktiv Maddə / Emulqator 4745" },
    categories: ["polyols-additives"],
    summary: {
      en: "Non-ionic surfactant and emulsifier for oilfield, industrial cleaning and process formulations.",
      az: "Neft mədəni, sənaye təmizliyi və proses formulaları üçün qeyri-ion səthi-aktiv maddə və emulqator.",
    },
    description: {
      en: "Surfactant / Emulsifier 4745 is a non-ionic surface-active agent used to stabilise emulsions, reduce interfacial tension and improve wetting in oilfield, industrial cleaning and metalworking formulations. Compatible with a wide range of base fluids.",
      az: "Səthi-aktiv maddə / Emulqator 4745 — neft mədəni, sənaye təmizliyi və metalemalı formulalarında emulsiyaları sabitləşdirmək, səthlərarası gərginliyi azaltmaq və islanmanı yaxşılaşdırmaq üçün istifadə olunan qeyri-ion səthi-aktiv agentdir. Geniş əsas mayelərlə uyğundur.",
    },
    spec: {
      "Forms Supplied": { en: "Concentrated liquid", az: "Qatılaşdırılmış maye" },
      "Appearance": { en: "Pale yellow to amber viscous liquid", az: "Açıq sarıdan kəhrəbaya qədər özlü maye" },
    },
    packaging: [
      { en: "200 kg drums", az: "200 kq bidonlar" },
      { en: "1000 kg IBC", az: "1000 kq IBC" },
    ],
    storage: {
      en: "Store in sealed containers in a cool, dry area away from strong oxidisers.",
      az: "Güclü oksidləşdiricilərdən uzaq, sərin və quru yerdə bağlı qablarda saxlayın.",
    },
  },

  // ── Industrial Tools & PPE ──────────────────────────────────────────────
  {
    slug: "industrial-hammer",
    group: "tools-ppe",
    name: { en: "Industrial Hammer", az: "Sənaye Çəkici" },
    summary: {
      en: "Heavy-duty hammer for general field, maintenance and assembly work on industrial sites.",
      az: "Sənaye obyektlərində ümumi sahə, texniki xidmət və yığma işləri üçün ağır iş çəkici.",
    },
    description: {
      en: "Forged industrial hammer designed for heavy-impact striking on construction, drilling and maintenance sites. Hardened steel head with shock-absorbing handle for prolonged use under demanding conditions.",
      az: "Tikinti, qazma və texniki xidmət sahələrində ağır zərbə üçün nəzərdə tutulmuş döyülmüş sənaye çəkici. Tələbkar şəraitdə uzunmüddətli istifadə üçün möhkəmləndirilmiş polad başlıq və zərbə sönükdürücü dəstək.",
    },
    spec: {
      Type: { en: "Sledge / club / claw configurations", az: "Balta, klub və caynaq konfiqurasiyaları" },
      Material: { en: "Forged carbon steel head, fibreglass or hickory handle", az: "Döyülmüş karbon polad başlıq, şüşə lifi və ya hikori dəstək" },
      Application: { en: "Construction, maintenance, drilling, mechanical assembly", az: "Tikinti, texniki xidmət, qazma, mexaniki yığma" },
    },
  },
  {
    slug: "drill-bits",
    group: "tools-ppe",
    name: { en: "Drill Bits (PDC / Tricone)", az: "Burğu Başlıqları (PDC / Trikon)" },
    summary: {
      en: "PDC and tricone (roller cone) bits for oil & gas, geothermal and water well drilling.",
      az: "Neft və qaz, geotermal və su quyusu qazması üçün PDC və trikon (rolikli) burğu başlıqları.",
    },
    description: {
      en: "Polycrystalline diamond compact (PDC) and tricone roller-cone drill bits engineered for performance across soft, medium and hard formations. Selected by formation type, hole diameter and required rate of penetration.",
      az: "Yumşaq, orta və sərt formasiyalarda performans üçün hazırlanmış polikristal almaz kompaktı (PDC) və trikon rolikli qazma başlıqları. Formasiya növü, quyu diametri və tələb olunan nüfuzetmə sürətinə görə seçilir.",
    },
    spec: {
      Type: { en: "PDC fixed-cutter / Tricone roller-cone", az: "PDC sabit kəsicili / Trikon rolikli" },
      Material: { en: "Steel body, tungsten carbide / PDC inserts, TCI cones", az: "Polad gövdə, volfram karbid / PDC kəsicilər, TCI konuslar" },
      Application: { en: "Oil & gas, geothermal and water well drilling", az: "Neft və qaz, geotermal və su quyusu qazması" },
    },
  },
  {
    slug: "pipe-cutter",
    group: "tools-ppe",
    name: { en: "Pipe Cutter", az: "Boru Kəsici" },
    summary: {
      en: "Manual and hydraulic pipe cutters for clean, square cuts on steel, copper and stainless tubing.",
      az: "Polad, mis və paslanmayan borularda təmiz, düzbucaqlı kəsiklər üçün əl və hidravlik boru kəsicilər.",
    },
    description: {
      en: "Pipe cutters for field and workshop use, available in ratcheting, rotary and hydraulic versions. Designed to deliver burr-free, perpendicular cuts that prepare pipework for welding or threaded fittings.",
      az: "Sahə və emalatxana istifadəsi üçün boru kəsicilər; ratçet, fırlanan və hidravlik variantlarda mövcuddur. Qaynağa və ya rezbalı birləşmələrə hazırlanmış borular üçün burunsuz, perpendikulyar kəsik təmin edir.",
    },
    spec: {
      Type: { en: "Rotary, ratcheting and hydraulic", az: "Fırlanan, ratçet və hidravlik" },
      Material: { en: "Hardened steel cutting wheels, alloy frame", az: "Möhkəmləndirilmiş polad kəsmə təkərləri, ərinti gövdə" },
      Application: { en: "Plumbing, pipeline maintenance, mechanical workshops", az: "Su təchizatı, boru kəməri texniki xidməti, mexaniki emalatxanalar" },
    },
  },
  {
    slug: "impact-wrench",
    group: "tools-ppe",
    name: { en: "Impact Wrench", az: "Pnevmatik Açar" },
    summary: {
      en: "High-torque pneumatic and electric impact wrenches for fastening and removing heavy bolts.",
      az: "Ağır boltların bağlanması və açılması üçün yüksək momentli pnevmatik və elektrik pnevmatik açarlar.",
    },
    description: {
      en: "Industrial impact wrenches designed for assembly, automotive and oilfield service work. Deliver controlled high-torque output to make and break threaded connections quickly and safely.",
      az: "Yığma, avtomobil və neft mədəni xidməti işləri üçün nəzərdə tutulmuş sənaye pnevmatik açarlar. Rezbalı birləşmələri tez və təhlükəsiz bağlamaq və açmaq üçün nəzarət olunan yüksək moment təmin edir.",
    },
    spec: {
      Type: { en: "Pneumatic and battery-electric", az: "Pnevmatik və akkumulyatorlu elektrik" },
      Material: { en: "Composite or alloy housing, steel anvil", az: "Kompozit və ya ərinti gövdə, polad zindan" },
      Application: { en: "Heavy-duty fastening, oilfield and automotive service", az: "Ağır iş bağlamaları, neft mədəni və avtomobil xidməti" },
    },
  },
  {
    slug: "industrial-drill",
    group: "tools-ppe",
    name: { en: "Industrial Drill", az: "Sənaye Drili" },
    summary: {
      en: "Corded and cordless industrial drills for metal, masonry and structural fabrication tasks.",
      az: "Metal, divar və konstruksiya istehsalı işləri üçün şəbəkə və simsiz sənaye drilləri.",
    },
    description: {
      en: "Heavy-duty rotary and hammer drills for industrial environments. Variable-speed motors and reinforced gearboxes support continuous use in fabrication, maintenance and structural installation.",
      az: "Sənaye mühitləri üçün ağır iş fırlanan və zərbəli drillər. Dəyişən sürətli mühərriklər və gücləndirilmiş ötürmə qutuları istehsalda, texniki xidmətdə və konstruksiya quraşdırmasında davamlı istifadəni dəstəkləyir.",
    },
    spec: {
      Type: { en: "Rotary / hammer / magnetic-base options", az: "Fırlanan / zərbəli / maqnit əsaslı variantlar" },
      Material: { en: "Reinforced housing, hardened steel chuck", az: "Gücləndirilmiş gövdə, möhkəmləndirilmiş polad patron" },
      Application: { en: "Metalworking, masonry, structural assembly", az: "Metalemalı, divar işləri, konstruksiya yığması" },
    },
  },
  {
    slug: "atex-non-sparking-tool-kits",
    group: "tools-ppe",
    name: { en: "ATEX Non-Sparking Tool Kits", az: "ATEX Qığılcımsız Alət Dəstləri" },
    summary: {
      en: "Certified non-sparking tool kits for use in flammable and explosive atmospheres.",
      az: "Alovlanan və partlayıcı atmosferlərdə istifadə üçün sertifikatlaşdırılmış qığılcımsız alət dəstləri.",
    },
    description: {
      en: "ATEX-rated tool kits manufactured from non-ferrous alloys to eliminate sparks during use. Specified for refineries, gas plants, chemical facilities and any zone classified for explosive atmospheres.",
      az: "İstifadə zamanı qığılcımı aradan qaldırmaq üçün qara olmayan ərintilərdən hazırlanmış ATEX-sertifikatlı alət dəstləri. Neft emalı zavodları, qaz müəssisələri, kimya obyektləri və partlayıcı atmosfer üçün təsnif edilmiş hər hansı bir zona üçün təyin olunur.",
    },
    spec: {
      Type: { en: "Spanners, hammers, wrenches, screwdrivers", az: "Açarlar, çəkiclər, pnevmatik açarlar, vintaçanlar" },
      Material: { en: "Beryllium-copper or aluminium-bronze alloy", az: "Berillium-mis və ya alüminium-bürünc ərinti" },
      Application: { en: "ATEX zones — refineries, gas plants, chemical facilities", az: "ATEX zonaları — neft emalı zavodları, qaz müəssisələri, kimya obyektləri" },
    },
  },
  {
    slug: "hydraulic-jack",
    group: "tools-ppe",
    name: { en: "Hydraulic Jack", az: "Hidravlik Domkrat" },
    summary: {
      en: "Bottle and trolley hydraulic jacks for heavy lifting in industrial and field applications.",
      az: "Sənaye və sahə tətbiqlərində ağır qaldırma üçün şüşə və arabalı hidravlik domkratlar.",
    },
    description: {
      en: "High-capacity hydraulic jacks built for stable, controlled lifting of heavy equipment, vehicles and structural elements. Steel construction with overload protection for safe operation under load.",
      az: "Ağır avadanlıq, nəqliyyat vasitələri və konstruksiya elementlərinin sabit və idarə olunan qaldırılması üçün yüksək tutumlu hidravlik domkratlar. Yük altında təhlükəsiz işləməsi üçün həddindən artıq yükə qarşı qoruma ilə polad konstruksiya.",
    },
    spec: {
      Type: { en: "Bottle / trolley / long-ram configurations", az: "Şüşə / arabalı / uzun-ram konfiqurasiyaları" },
      Material: { en: "Heavy-gauge steel body, hardened ram", az: "Ağır ölçülü polad gövdə, möhkəmləndirilmiş ram" },
      Application: { en: "Lifting heavy equipment, vehicles and structures", az: "Ağır avadanlıq, nəqliyyat vasitələri və konstruksiyaların qaldırılması" },
    },
  },
  {
    slug: "hydraulic-pump",
    group: "tools-ppe",
    name: { en: "Hydraulic Pump", az: "Hidravlik Nasos" },
    summary: {
      en: "Hand and electric hydraulic pumps for tools, jacks, presses and tensioning equipment.",
      az: "Alətlər, domkratlar, preslər və gərginlik avadanlığı üçün əl və elektrik hidravlik nasoslar.",
    },
    description: {
      en: "Manual, pneumatic and electric hydraulic pumps engineered to power tools, cylinders and tensioning systems. High-pressure output suitable for bolt tensioning, lifting and industrial press applications.",
      az: "Alətləri, silindrləri və gərginlik sistemlərini hərəkətə gətirmək üçün hazırlanmış əl, pnevmatik və elektrik hidravlik nasoslar. Bolt gərginləşdirilməsi, qaldırma və sənaye pres tətbiqləri üçün uyğun yüksək təzyiqli çıxış.",
    },
    spec: {
      Type: { en: "Manual, pneumatic and electric", az: "Əl, pnevmatik və elektrik" },
      Material: { en: "Steel body with corrosion-resistant finish", az: "Korroziyaya davamlı örtüklü polad gövdə" },
      Application: { en: "Powering hydraulic tools, jacks, presses, tensioners", az: "Hidravlik alətlərin, domkratların, preslərin, gərginləşdiricilərin işlədilməsi" },
    },
  },
  {
    slug: "protective-gloves",
    group: "tools-ppe",
    name: { en: "Protective Gloves", az: "Qoruyucu Əlcəklər" },
    summary: {
      en: "Industrial work, chemical-resistant and cut-resistant gloves for site and laboratory use.",
      az: "Obyekt və laboratoriya istifadəsi üçün sənaye iş, kimyəvi davamlı və kəsməyə davamlı əlcəklər.",
    },
    description: {
      en: "Range of certified protective gloves covering mechanical, chemical, thermal and cut hazards. Selected by application: nitrile and neoprene for chemical handling, leather for general work, HPPE for cut protection.",
      az: "Mexaniki, kimyəvi, termik və kəsmə təhlükələrini əhatə edən sertifikatlı qoruyucu əlcəklər çeşidi. Tətbiqə görə seçilir: kimyəvi maddələrlə iş üçün nitril və neopren, ümumi iş üçün dəri, kəsmədən qorunma üçün HPPE.",
    },
    spec: {
      Type: { en: "Nitrile, neoprene, leather, HPPE / cut-resistant", az: "Nitril, neopren, dəri, HPPE / kəsməyə davamlı" },
      Material: { en: "Synthetic rubber, leather or HPPE fibre", az: "Sintetik rezin, dəri və ya HPPE lifi" },
      Application: { en: "Chemical handling, general industry, mechanical work", az: "Kimyəvi maddələrlə iş, ümumi sənaye, mexaniki iş" },
    },
  },
  {
    slug: "protective-clothing",
    group: "tools-ppe",
    name: { en: "Protective Clothing", az: "Qoruyucu Geyim" },
    summary: {
      en: "Coveralls, FR clothing and chemical suits for industrial and oilfield environments.",
      az: "Sənaye və neft mədəni mühitləri üçün kombinezonlar, alova davamlı geyim və kimyəvi kostyumlar.",
    },
    description: {
      en: "Industrial protective clothing including flame-resistant (FR) coveralls, chemical splash suits and high-visibility workwear. Compliant with international standards for oil & gas, petrochemical and construction operations.",
      az: "Alova davamlı (FR) kombinezonlar, kimyəvi sıçramaya qarşı kostyumlar və yüksək görünən iş geyimi daxil olmaqla sənaye qoruyucu geyim. Neft və qaz, neft-kimya və tikinti əməliyyatları üçün beynəlxalq standartlara uyğundur.",
    },
    spec: {
      Type: { en: "FR coveralls, chemical suits, hi-vis workwear", az: "FR kombinezonlar, kimyəvi kostyumlar, hi-vis iş geyimi" },
      Material: { en: "Aramid, modacrylic, treated cotton or composite", az: "Aramid, modakril, emal olunmuş pambıq və ya kompozit" },
      Application: { en: "Oil & gas, petrochemical, construction, utilities", az: "Neft və qaz, neft-kimya, tikinti, kommunal" },
    },
  },
  {
    slug: "safety-goggles",
    group: "tools-ppe",
    name: { en: "Safety Goggles", az: "Qoruyucu Eynəklər" },
    summary: {
      en: "Impact, splash and dust protection eyewear for workshops, plants and laboratories.",
      az: "Emalatxanalar, müəssisələr və laboratoriyalar üçün zərbə, sıçrayış və tozdan qoruyucu eynəklər.",
    },
    description: {
      en: "Polycarbonate safety goggles offering impact, chemical splash and dust protection. Anti-fog and anti-scratch coatings available; compatible with prescription glasses and full-face respirators.",
      az: "Zərbə, kimyəvi sıçrayış və tozdan qorunma təklif edən polikarbonat qoruyucu eynəklər. Dumana və cızılmaya qarşı örtüklər mövcuddur; reseptli eynəklər və tam üz respiratorları ilə uyğundur.",
    },
    spec: {
      Type: { en: "Direct vent, indirect vent and sealed", az: "Birbaşa havalandırma, dolayı havalandırma və bağlı" },
      Material: { en: "Polycarbonate lens, elastomer frame", az: "Polikarbonat linza, elastomer çərçivə" },
      Application: { en: "Workshops, chemical handling, drilling, laboratories", az: "Emalatxanalar, kimyəvi maddələrlə iş, qazma, laboratoriyalar" },
    },
  },
  {
    slug: "flame-resistant-balaclava",
    group: "tools-ppe",
    name: { en: "Flame-Resistant Balaclava", az: "Alova Davamlı Balaklava" },
    summary: {
      en: "FR balaclava for head, neck and face protection in arc-flash and flame-exposure environments.",
      az: "Qövs alovu və alovla təmas mühitlərində baş, boyun və üzü qorumaq üçün alova davamlı balaklava.",
    },
    description: {
      en: "Flame-resistant balaclava worn under helmets and hoods to protect the head and neck from heat, arc flash and flame exposure. Suitable for welders, oilfield personnel and emergency-response teams.",
      az: "Başı və boynu istidən, qövs alovundan və alovdan qorumaq üçün dəbilqə və kapüşonlar altında geyilən alova davamlı balaklava. Qaynaqçılar, neft mədəni heyəti və təcili yardım komandaları üçün uyğundur.",
    },
    spec: {
      Type: { en: "Single or double-layer FR knit", az: "Tək və ya iki qatlı FR toxuma" },
      Material: { en: "Aramid / modacrylic blend", az: "Aramid / modakril qarışığı" },
      Application: { en: "Welding, oil & gas, emergency response, utilities", az: "Qaynaq, neft və qaz, təcili yardım, kommunal" },
    },
  },
];

export const partners = [
  {
    name: "SOCAR",
    logo: "https://customer-assets.emergentagent.com/job_bakuchem-corporate/artifacts/t4k7upba_logo2.png",
  },
  {
    name: "Azpetrol",
    logo: "https://customer-assets.emergentagent.com/job_bakuchem-corporate/artifacts/rqlnvqkw_azpetrol.jpg",
  },
  {
    name: "Lukoil",
    logo: "https://customer-assets.emergentagent.com/job_bakuchem-corporate/artifacts/hkyp6yj1_LUK_OIL_Logo.svg.png",
  },
  {
    name: "Azfen",
    logo: "https://customer-assets.emergentagent.com/job_bakuchem-corporate/artifacts/elfxzs8c_tekfen-wh.png",
  },
  {
    name: "Baku Hotel Company",
    logo: "https://customer-assets.emergentagent.com/job_bakuchem-corporate/artifacts/u4s8ronf_logo-2-1707745086.png",
  },
];

export function getProductsByCategory(slug) {
  return products.filter((p) => Array.isArray(p.categories) && p.categories.includes(slug));
}

export function getProductsByGroup(slug) {
  if (slug === "chemicals") {
    return products.filter((p) => p.group !== "tools-ppe");
  }
  return products.filter((p) => p.group === slug);
}

export function getProductGroup(product) {
  return product?.group === "tools-ppe" ? "tools-ppe" : "chemicals";
}

export function getGroup(slug) {
  return groups.find((g) => g.slug === slug);
}

export function getProduct(slug) {
  return products.find((p) => p.slug === slug);
}

export function getCategory(slug) {
  return categories.find((c) => c.slug === slug);
}
